import { createContext } from "react";
import { Tenant } from "../../types";

export const DefaultTenant: Tenant = {
  tenantName: "Jameo",
  logo: {
    logo: "/jameo_logo.svg",
    logomark: "/J_logo.svg",
  },
  tenantId: "default",
};

export const TenantContext = createContext<{
  tenant: Tenant;
  isTenantLoading: boolean;
}>({
  tenant: DefaultTenant,
  isTenantLoading: false,
});

// note:
//
//propager reset passwork / kjoined team

// home title

// logo: studio & toolbar
